import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnersDisplayGridRowDataFragmentGql } from './OwnersDisplayGridRowFragmentGql';

// Should fetch same nodes as DatabaseDownstreamOwnerIdsQuery
export const DatabaseDownstreamOwnersQueryGql: DocumentNode = gql`
query DatabaseDownstreamOwnersQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  databases(filter: { id: $databaseId }) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowDataFragment
      }
    }
  }
}
${OwnersDisplayGridRowDataFragmentGql}
`;
